module.exports = __webpack_public_path__ + "static/img/course-a.0076ba83.png";